import React, { InputHTMLAttributes, MouseEventHandler } from 'react'

import { StyledToggle as S } from './Toggle.styles'

type TBaseProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'checked' | 'type' | 'onChange' | 'onClick'
>

type TProps = TBaseProps & {
  className?: string
  checked: boolean
  onChange: (isChecked: boolean) => void
  onClick?: MouseEventHandler<HTMLLabelElement>
}

export const Toggle: React.FC<TProps> = ({
  checked,
  className,
  onClick,
  onChange,
  ...props
}) => {
  return (
    <S.Wrapper className={className} onClick={onClick}>
      <S.Input
        type="checkbox"
        checked={checked}
        onChange={({ target }: React.ChangeEvent<HTMLInputElement>) => {
          onChange(target.checked)
        }}
        {...props}
      />
      <S.Toggle />
    </S.Wrapper>
  )
}
